import { AgreeTermsRequest } from 'src/models/agreeTerms';
import { fetchApi } from '../baseApi';

export function submitAgreeTerms(request: AgreeTermsRequest) {
    return new Promise((resolve, reject) => {
        fetchApi(`api/registrations/agree_terms`, 'POST', request).then((result) => {
            resolve(result);
        }).catch((e) => {
            reject(new Error('Cannot submit agree terms!'));
        });
    });
}


// WEBPACK FOOTER //
// ./src/api/agreeTerms/index.ts